import useAxiosFunction from 'hooks/useAxiosFunction';
import React, { useEffect, useRef, useState } from 'react'

const Dropdown = (props) => {
    const { name, renderFunc, setValue, register, handleSubmit, watch, control, isClean, validation, parentId,
        urlfetch, className, icon, error, label,
        placeholder, options, valueId, labelId, mb = "3",
        defaultValue, ...rest } = props
    const [respax, errax, loadingax, fetchax] = useAxiosFunction();
    const clsName = `${icon ? "input" : "form"}-group mb-${mb}`
    const [myoptions, setMyoptions] = useState(options)
    const nested = defaultValue && parentId ? true : false
    const appliedDefaultRef = useRef(null)

    useEffect(() => {
        if (respax?.data) {
            setMyoptions(respax?.data)
            setValue(name, defaultValue?.[name])
        }
    }, [respax])

    useEffect(() => {
        setMyoptions(options)
    }, [options])

    useEffect(() => {
        if (!name) return

        let shouldApplyDefault = defaultValue !== undefined
        let nextDefaultValue = defaultValue
        if (defaultValue && typeof defaultValue === "object" && !Array.isArray(defaultValue)) {
            shouldApplyDefault = Object.prototype.hasOwnProperty.call(defaultValue, name)
            nextDefaultValue = shouldApplyDefault ? (defaultValue?.[name] ?? "") : ""
        }
        if (!shouldApplyDefault) return

        const nextDefaultKey = JSON.stringify(nextDefaultValue ?? "")
        if (appliedDefaultRef.current === nextDefaultKey) return

        appliedDefaultRef.current = nextDefaultKey
        setValue(name, nextDefaultValue ?? "")
    }, [defaultValue, name, setValue])

    useEffect(() => {
        if (nested && urlfetch) {
            const urltofetch = defaultValue?.[parentId] ? urlfetch + "/" + defaultValue?.[parentId] : ""
            if (urltofetch) {
                fetchax({ method: "GET", url: urltofetch, auth: true })
            }
        }
    }, [])

    return (
        name && <div className={isClean ? "" : clsName}>
            {label && <label>{label}</label>}
            <select {...register(name, validation)} className={`form-control ${error ? "is-invalid" : ""} ${className}`} {...rest} >
                {placeholder !== "" && <option value="">{placeholder}</option>}
                {myoptions.map((opt, idx) => {
                    return <option key={idx} value={opt[valueId]}>{opt[labelId]}</option>
                })}
            </select>

            {icon && <div className="input-group-append">
                <div className="input-group-text">
                    <span className={`fas ${icon}`} />
                </div>
            </div>}
            {error && <span className="error invalid-feedback">{error}</span>}
        </div>
    )
}

Dropdown.defaultProps = {
    register: () => { },
    setValue: () => { },
    name: "",
    validation: {},
    icon: "",
    className: "",
    error: "",
    label: "",
    placeholder: "",
    options: [],
    valueId: "",
    labelId: "",
    isClean: false
}
export default Dropdown
